/* eslint-disable @typescript-eslint/no-use-before-define */
export function debounce(timeout: number) {
    return function(target: any, key: string | symbol, descriptor: PropertyDescriptor) {
        // 获取被装饰的方法
        const fn = descriptor.value
        // 初始timerID
        let timer: any = null
        // 覆盖被装饰的方法
        descriptor.value = async function(...args: any) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                fn.call(this, ...args)
            }, timeout)
        }
        return descriptor
    }
}
/**
 * 限流装饰器
 * @param timeout
 * @returns
 */
export function throttle(timeout: number) {
    return function(target: any, key: string | symbol, descriptor: PropertyDescriptor) {
        // 获取被装饰的方法
        const fn = descriptor.value
        // 初始timerID
        let timer: any = null
        // 覆盖被装饰的方法
        descriptor.value = async function(...args: any) {
            if (timer) {
                return
            }
            timer = setTimeout(() => {
                fn.call(this, ...args)
                timer = null
            }, timeout)
        }
        return descriptor
    }
}
